import script from "./createList.vue?vue&type=script&setup=true&lang=js"
export * from "./createList.vue?vue&type=script&setup=true&lang=js"

import "./createList.vue?vue&type=style&index=0&id=d893340c&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d893340c"]])

export default __exports__